/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IPasswordResetVerificationLoadingMessage {
    className: string;
    message: string;
}

const PasswordResetVerificationLoadingMessage: React.FC<IPasswordResetVerificationLoadingMessage> = ({ className, message }) => (
    <div className={`${className}__loading-message`}>{message}</div>
);

export default PasswordResetVerificationLoadingMessage;
